<template>
  <b-container fluid class="animated fadeIn">
    <h1>Dashboard</h1>

    <b-row>
      <b-col md="12">
        <b-card>
          <b-row class="justify-content-center my-2">
            <b-col sm="12" md="10" lg="8" xl="4">
              <label class="d-md-none d-sm-flex">Período Monitoramento</label>
              <b-input-group
                id="data-monitoramento"
                class="mb-3 d-md-flex"
                prepend="Período Monitoramento:"
              >
              <vue-monthly-picker ref="dataMonitoramentoField" :clearOption="false" v-model="dataMonitoramento" dateFormat="MM/YYYY" :monthLabels="labelMes" :disabled="isConsultando"/>
                <b-input-group-append>
                  <b-button @click="focusDataMonitoramento();"  @click.stop.prevent="focusDataMonitoramento();" size="sm" text="Data" variant="primary"> <!---->
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row class="justify-content-around">
            <b-col md="6" class="d-flex justify-content-center my-2">
              <div class="passo passo_inativo">
                <img
                  src="../../assets/img/icones/cda.png"
                  alt="Quantidade de CDAs disponibilizadas pela SEFA no mês de referência"
                  v-b-tooltip.hover
                  title="Quantidade de CDAs disponibilizadas no período"
                />
              </div>
              <template v-if="quantidadeTotalDividas !=  null">
                  <span class="destaque my-auto">{{quantidadeTotalDividas}}</span>
              </template>
              <template v-else>
                  <span class="destaque my-auto">Carregando..</span>
              </template>
            
            </b-col>

            <b-col md="6" class="d-flex justify-content-center my-2">
              <div class="passo passo_inativo">
                <img
                  src="../../assets/img/icones/movimentacao.png"
                  alt="Quantidade de CDAs disponibilizadas pela SEFA no mês de referência"
                  v-b-tooltip.hover
                  title="Valor das CDAs disponibilizadas no período"
                />
              </div>
              <template v-if="quantidadeTotalDividas !=  null">
                  <span class="destaque my-auto" >R$ {{valorTotalDividas | currency}}</span>
              </template>
              <template v-else>
                <span class="destaque my-auto" >Carregando..</span>
              </template>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6">
        <CompProtestos ref="compProtestos" @atualizarDadosGerais="atualizarDadosGerais"/>
      </b-col>
      <b-col lg="6">
        <CompAjuizamentos ref="compAjuizamentos" @atualizarDadosGerais="atualizarDadosGerais"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex'
import CompProtestos from "./components/CompProtestos";
import CompAjuizamentos from "./components/CompAjuizamentos";
import axios from 'axios'

export default {
  components: {
    CompProtestos,
    CompAjuizamentos
  },
  data() {
    return {
      dataMonitoramento: null,
      quantidadeTotalDividas: null,
      valorTotalDividas: null,
      isConsultando: false,
      firstSearch: true,
      resultadoGeral: [],
      labelMes: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    }
  },
  
  methods: {
    ...mapActions(['setDataMonitoramento']),
    atualizarDadosGerais(){
      if(!isNaN(this.$refs.compProtestos.obterValorGeral() + this.$refs.compAjuizamentos.obterValorGeral())){
        this.valorTotalDividas= this.resultadoGeral.valorGeral
        this.isConsultando = false;
      }
      if(!isNaN(this.$refs.compProtestos.obterQtdeGeral() + this.$refs.compAjuizamentos.obterQtdeGeral())){
        this.quantidadeTotalDividas = this.resultadoGeral.qtdeGeral
        this.isConsultando = false;
      }
      if(this.quantidadeTotalDividas == 0){
         this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Não há CDAs obtidas no período.'] });
      }
    },
    focusDataMonitoramento(){
      this.$refs.dataMonitoramentoField.openMenu();
    },
    async consultarValorGeral(ano,mes) {
          this.ano = ano
          this.mes = mes
          
          const token = JSON.parse(this.$store.getters.getUser).access_token;
          const urlApi = process.env.VUE_APP_ROOT_API
          
          axios.post(`${urlApi}/v1/monitoramentoDividas/consultarGeral/${this.ano}/${this.mes}`, ``, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
              }
          })
          .then(response => {
              this.resultadoGeral = response.data
          }).finally(() => {
             this.atualizarDadosGerais()
          })
        },
    },

  watch: {
    dataMonitoramento() {
       if(this.firstSearch){
          this.quantidadeTotalDividas = null;
          this.valorTotalDividas = null;
          this.isConsultando = true;
          this.$refs.compAjuizamentos.consultarAjuizamento(this.ano, this.mes);
          this.$refs.compProtestos.consultarProtesto(this.ano, this.mes);
          this.consultarValorGeral(this.ano, this.mes)
          this.firstSearch = false;
       }else{
          this.quantidadeTotalDividas = null
          this.valorTotalDividas = null
          const dataSelecionada = new Date(this.dataMonitoramento._i + "/02");
          this.ano = dataSelecionada.getFullYear();
          this.mes = dataSelecionada.getMonth() + 1;  
          this.quantidadeTotalDividas = null;
          this.valorTotalDividas = null;
          this.isConsultando = true;
          this.$refs.compAjuizamentos.consultarAjuizamento(this.ano, this.mes);
          this.$refs.compProtestos.consultarProtesto(this.ano, this.mes);
          this.consultarValorGeral(this.ano, this.mes)
          this.$store.commit('setDataMonitoramento', dataSelecionada)
       }
       //alterar para somar total de cada componente
    }
  },

  mounted() {
    //  this.$refs.dataMonitoramentoField.openMenu();
    this.firstSearch = true;
    var dataAtual = new Date();
    const dataAtualRep = new Date(this.$store.getters.getDataMonitoramento);
    if(dataAtualRep != null){
      dataAtual = dataAtualRep;
    }
    
    this.ano = dataAtual.getFullYear();
    this.mes = dataAtual.getMonth() + 1;
    
    this.dataMonitoramento = this.ano + "-" + this.mes + "-" + "02";
    const dataSelecionada = new Date(this.ano + "/" + this.mes + "/02");
    this.$store.commit('setDataMonitoramento', dataSelecionada)
  }
};
</script>


<style scoped>

</style>
